import { Component, forwardRef, OnDestroy, OnInit } from "@angular/core"
import {
    AbstractControl,
    ControlValueAccessor,
    FormBuilder,
    FormControl,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    ValidationErrors,
    Validator,
    Validators,
} from "@angular/forms"
import { UserProfileService } from "../../services/user-profile.service"
import { Subject } from "rxjs"
import { takeUntil, tap } from "rxjs/operators"

@Component({
    selector: "app-user-profile-role-selector",
    templateUrl: "./user-profile-role-selector.component.html",
    styleUrls: ["./user-profile-role-selector.component.scss"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => UserProfileRoleSelectorComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: forwardRef(() => UserProfileRoleSelectorComponent),
        },
    ],
})
export class UserProfileRoleSelectorComponent
    implements OnInit, OnDestroy, ControlValueAccessor, Validator {
    private destroy$ = new Subject()

    onChange = (val) => {}
    onTouched = () => {}

    roles: string[] = []

    userRoleControl: FormControl
    otherInputControl: FormControl

    isVisible = false
    roleSelected = "Choose Role"
    isDisabled

    constructor(private fb: FormBuilder, private userProfileService: UserProfileService) {}

    ngOnInit(): void {
        this.roles = this.userProfileService.getTeacherRoles()
        this.userRoleControl = this.fb.control("", Validators.required)

        this.otherInputControl = this.fb.control("")
        this.otherInputControl.valueChanges
            .pipe(
                takeUntil(this.destroy$),
                tap((data) => (this.roleSelected = data))
            )

            .subscribe((data) => this.userRoleControl.patchValue(data))
    }

    ngOnDestroy(): void {
        this.destroy$.next()
        this.destroy$.complete()
    }

    writeValue(role: any): void {
        // if the userRole was added under "Other" option, map it to the same option
        const found = this.roles.find((el) => el === role)
        if (!found) {
            this.otherInputControl.setValue(role)
        }

        this.roleSelected = role
        this.userRoleControl.setValue(role)
    }

    registerOnChange(fn: any): void {
        this.userRoleControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(fn)
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled
    }

    validate(control: AbstractControl): ValidationErrors | null {
        return this.userRoleControl?.value?.trim().length > 0
            ? null
            : {
                  error: {
                      message: this.validationMessage(),
                  },
              }
    }

    validationMessage(): string {
        if (this.userRoleControl?.value && !this.userRoleControl?.value.match(/^[A-Za-z]/)) {
            return "Please enter a valid role name."
        } else if (!this.userRoleControl?.value) {
            return "Please select a role!"
        }
    }

    onRoleClicked(role): void {
        this.roleSelected = role
        this.userRoleControl.setValue(role)
    }

    onOtherClicked(): void {
        this.isVisible = !this.isVisible
    }
}
